<template>
    <div>
      <Header :pageIndex="4" />
      <CBanner img-url="/static/banner8.png" title1="加入我们" title-en="Join Us" title2="我们拥有良好的办公环境，相处融洽的小伙伴，五险一金，节假日休息，定期员工体检，带薪假期，年底还有丰厚奖金，快快加入我们吧"/>
      <div class="join-title">虚位以待&nbsp;&nbsp;&nbsp;&nbsp;诚聘英才&nbsp;&nbsp;&nbsp;&nbsp;高薪礼聘&nbsp;&nbsp;&nbsp;&nbsp;就等你来</div>
      <CTeam/>
      <CTitle title="/static/address-concat.png" desc="Address"/>
      <CAddress/>
      <CToTop/>
    </div>
</template>

<script>
    import CBanner from "@/components/CBanner";
    import CTeam from "@/components/CTeam";
    import CTitle from "@/components/CTitle";
    import CAddress from "@/components/CAddress";
    import CToTop from "@/components/CToTop";
    import Header from "../Header";
    export default {
        name: "JoinUs",
      components: {Header, CToTop, CAddress, CTeam,CTitle, CBanner}
    }
</script>

<style scoped>
.join-title{
  font-size: 32px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
  margin-top: 70px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contains/JoinUs.vue